import React from "react";
import { RenderProps } from "@models/carousel";
import { motion } from "framer-motion";
import { OneTesimonialModel } from "@models/strapi-components/testimonials";
import ImageRenderer from "@components/common/Image";
import Button from "@components/common/Button";
import Link from "@components/common/Link";
import Title from "@components/common/Title";

const OneTestimonial: React.FunctionComponent<
  RenderProps<OneTesimonialModel>
> = ({ data, ...rest }) => {
  const { text, id, logo, name, designation, ctaLink, ctaText } = data;

  const renderCTAButton = () =>
    ctaText &&
    ctaLink && (
      <Button variant="border" className="!p-0">
        <Link
          href={ctaLink}
          className="text-inherit no-underline px-8 py-3 block hover:font-normal"
          linkText={ctaText}
          wrapperClassName="text-inherit xl:text-inherit"
          style={{ fontSize: "inherit" }}
        />
      </Button>
    );

  return (
    <motion.div
      key={id}
      className="flex flex-col items-center justify-center"
      {...rest}
    >
      <div className="flex justify-center mb-6">
        <ImageRenderer image={logo} />
      </div>
      <Title
        variant="paragraph"
        titleText={text}
        className="max-w-[620px] text-center font-normal xl:text-[18px] mb-0"
      />
      <div className="mt-6 mb-6 xl:mb-8 xl:mt-8">
        <Title
          variant="h3"
          titleText={name}
          className="max-w-[620px] text-center mb-0 font-semibold"
        />
        <Title
          variant="paragraph"
          titleText={designation}
          className="max-w-[620px] text-center text-gray-500"
        />
      </div>
      {renderCTAButton()}
    </motion.div>
  );
};
export default OneTestimonial;
